import React, { ReactElement } from 'react'

import sortOptionsConfig, {
  RecipeSortId,
} from '@mindfulchefuk/config/sortOptionsConfig'
import { Dropdown, Stack } from '@mindfulchefuk/design-system'
import { RadioButton } from '@mindfulchefuk/design-system/Forms/RadioButton/RadioButton'
import { RecipeFilter } from './RecipeFilter'
import { RecipeFilterHandlers } from './RecipeFilter.types'

type TRecipeFilterSort = {
  onChange: RecipeFilterHandlers['sortBy']
  onToggle: () => void
  isOpen: boolean
  recipesSortedBy: RecipeSortId
}

export const RecipeFilterSort = ({
  onChange,
  onToggle,
  isOpen,
  recipesSortedBy,
}: TRecipeFilterSort): ReactElement => {
  const label = sortOptionsConfig.find(
    ({ id }) => id === recipesSortedBy
  )?.title

  return (
    <RecipeFilter
      id="sort-by"
      label={label}
      icon="sort"
      onToggle={onToggle}
      isOpen={isOpen}
    >
      <Dropdown
        onToggle={onToggle}
        isOpen={isOpen}
        alignment={{ base: 'left', sm: 'right' }}
        width={224}
      >
        <Stack spacing={10}>
          {sortOptionsConfig.map(({ id, title }) => {
            const key = `sort-by-${id}`
            return (
              <RadioButton
                id={key}
                key={key}
                data-testid={`${key}-radio`}
                value={id}
                onChange={(event) =>
                  onChange(event.target.value as RecipeSortId)
                }
                checked={id === recipesSortedBy}
              >
                {title}
              </RadioButton>
            )
          })}
        </Stack>
      </Dropdown>
    </RecipeFilter>
  )
}
